"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jq = exports.jqueryGet = exports.jsonFromjQuery = void 0;
var jsonFromjQuery = function (jQueryElement) {
    //Validate element
    if (!jQueryElement || !jQueryElement.length)
        throw new Error("Invalid jQuery Element for parsing");
    //Get HTML contents
    var contents = jQueryElement.html();
    //Attempt to parse
    return JSON.parse(contents);
};
exports.jsonFromjQuery = jsonFromjQuery;
var jqueryGet = function () {
    return (window['$'] || window['jQuery'] || window['jquery'] ||
        window['Checkout']['jQuery'] || window['Checkout']['$']);
};
exports.jqueryGet = jqueryGet;
exports.jq = (0, exports.jqueryGet)();
//# sourceMappingURL=index.js.map